var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.047,
    height: 15.047,
    viewBox: "0 0 15.047 15.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M9.141-9l5.813,5.813a.342.342,0,0,1,0,.516L13.875-1.594a.342.342,0,0,1-.516,0l-.984-1.031L7.547-7.406,1.734-1.594a.342.342,0,0,1-.516,0L.141-2.672a.342.342,0,0,1,0-.516L5.953-9,.141-14.812a.342.342,0,0,1,0-.516l1.078-1.078a.342.342,0,0,1,.516,0l5.813,5.813,5.813-5.812a.342.342,0,0,1,.516,0l1.078,1.078a.342.342,0,0,1,0,.516l-1.031.984Z",
    transform: "translate(-0.023 16.523)",
    fill: "#bfc0c3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimes);
export default __webpack_public_path__ + "static/media/times.8f96418c0ca5974344769e18e1b70ad6.svg";
export { ForwardRef as ReactComponent };